/**
 * An in-app path taken from an address (`?from=`) or storage, made safe to use
 * as a link or a navigation target.
 *
 * A prefix check is not enough: the URL parser drops tab and line breaks, so
 * `/\t/evil.example` passes `!startsWith('//')` and still resolves to
 * `https://evil.example/` (SEC-294). The value is resolved against the app's
 * own origin instead, and only a same-origin result is kept, as
 * `pathname + search + hash`. Control characters are refused outright.
 */
// eslint-disable-next-line no-control-regex
const CONTROL = /[\u0000-\u001f\u007f]/

export const safeInAppPath = (value: string | null | undefined, origin?: string): string | null => {
  if (!value || !value.startsWith('/') || CONTROL.test(value)) return null
  const base = origin ?? (typeof window !== 'undefined' ? window.location.origin : '')
  if (!base) return null
  try {
    const url = new URL(value, base)
    if (url.origin !== new URL(base).origin) return null
    return `${url.pathname}${url.search}${url.hash}`
  } catch {
    return null
  }
}
